import Vue from 'vue';

Vue.filter('percent', value => {
  if (!value) return '';

  return value * 100 + '%';
});
